import TrailerControllers from "../../../../pages-v1/TrailerControllers";

export const Page = TrailerControllers;
